module.exports = __webpack_public_path__ + "img/infoBg.4a7b81d3.png";